import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PaginatorService {
  listaDeItensPorPagina = [10, 30, 50];
  itensPorPagina = 10;

  constructor() { }

  consultarPaginacao() {
    const itensPorPagina = localStorage.getItem('itensPorPagina') || this.itensPorPagina.toString();

    return {
      paginacao: { tamanhoMaximo: 5, total: 0, paginaAtual: 1 },
      listaDeItensPorPagina: this.listaDeItensPorPagina,
      itensPorPagina: parseInt(itensPorPagina, 10)
    };
  }

  salvaPaginacao(itensPorPagina) {
    localStorage.setItem('itensPorPagina', itensPorPagina);
  }

  // v2
  getPageSize(): number {
    const itensPorPagina = localStorage.getItem('itensPorPagina') || this.itensPorPagina.toString();

    return parseInt(itensPorPagina, 10)
  }

  setPageSize(value: number): number {
    const pageSize = value || this.itensPorPagina;

    localStorage.setItem('itensPorPagina', pageSize.toString());
    return pageSize;
  }

  getPageSizeOptions(): number[] {
    return this.listaDeItensPorPagina;
  }
}
